import { IFlowApiAdapter } from '../flow-api-adapter/types';

export function renderNoIndexMetaTag(wixSdkAdapter: IFlowApiAdapter) {
  wixSdkAdapter.setRobotsNoIndex();
}
